export default __webpack_public_path__ + "static/media/mobile.b42ab230.svg";